import { PRODUCT_CONSTANTS } from '@/consts/ProductConst';

/**
 * ケンコス商品の販売制限の告知（一時的な掲示）。
 *
 * 出すのは3か所: トップ「人気の商品ランキング」でパーソナルケアのタブが表示されたとき／
 * ケンコス商品の詳細で「カートに入れる」を押したとき／チェックアウトを開いたときにカートへケンコスがあるとき。
 * どれも既存の `useDialog` で出し、「閉じる」で元の操作が続く（**購入は止めない**）。
 *
 * **戻すときは `ENABLED` を `false` にする。** 二度と使わないなら、このファイルと
 * 参照している3ファイル（`index/products.vue`・`products/detail/buy-forms.vue`・`checkout/index.client.vue`）の数行を消す。
 */

/** 色・フレーバーを選んで買う本体（K41〜K45）以外の、パーソナルケアのケンコス商品 */
const ACCESSORY_CODES = ['KF01', 'KF02', 'KF03', 'KF05', 'KF15', 'KG01', 'KG02'];

export const KENCOS_NOTICE_CONSTANTS = {
  ENABLED: true,
  /** ダイアログ本文は HTML として出る（`layouts/dialog/index.vue`）。色は既存の電話案内と同じくインラインで付ける */
  MESSAGE: '<span style="color: red; font-size: 18px;">KENCOS関連商品は、弊社でのご購入歴があるお客様に限り販売を行っています</span>',
  TITLE: '',
  /** 商品詳細のコード（`/products/<コード>`）。パーソナルケアのカード12商品と同じ */
  PRODUCT_CODES: [...PRODUCT_CONSTANTS.KENCOS.SERIES_CODE, ...ACCESSORY_CODES],
  /**
   * カートに入るコード。本体は色×フレーバーの組み合わせコード（SK411〜SK453）で入るため、
   * 商品詳細のコード（K41〜K45）では引けない。組み合わせは `PRODUCT_CONSTANTS.KENCOS.COMBINATION_MAP` が正
   */
  CART_CODES: [...Object.values(PRODUCT_CONSTANTS.KENCOS.COMBINATION_MAP), ...ACCESSORY_CODES],
} as const;
